import React from 'react';
import { Box, Typography, Container, Grid, Paper } from '@mui/material';
import DiamondIcon from '@mui/icons-material/Diamond';
import SecurityIcon from '@mui/icons-material/Security';
import PublicIcon from '@mui/icons-material/Public';

function Features() {
  const features = [
    { 
      title: 'Stablecoin', 
      desc: 'Every token is fully collateralized ', 
      icon: <DiamondIcon />
    },
    { 
      title: 'Secure & Transparent', 
      desc: 'Built on audited smart contracts ', 
      icon: <SecurityIcon />
    },
    { 
      title: 'Global & Accessible', 
      desc: 'Available 24/7 ', 
      icon: <PublicIcon />
    }
  ];

  return (
    <Box sx={{ py: { xs: 6, md: 8 }, backgroundColor: '#050505' }}>
      <Container maxWidth="lg">
        
        {/* Header */}
        <Typography variant="h3" component="h2" sx={{ fontFamily: "'Playfair Display', serif", color: '#ffffff', textAlign: 'center', mb: 1, fontSize: { xs: '2rem', md: '2.5rem' } }}>
          The Diamond Standard
        </Typography>
        <Typography variant="subtitle1" sx={{ color: '#d4af37', textAlign: 'center', mb: 6, textTransform: 'uppercase', letterSpacing: '3px', fontSize: '0.8rem' }}>
          The Future of Stable Assets
        </Typography>

        {/* Grid: STRICT 3 columns, Perfectly Horizontal */}
        <Grid container spacing={3} alignItems="stretch">
          {features.map((item, index) => (
            <Grid item xs={12} md={4} key={index} sx={{ height: '100%' }}>
              <Paper
                elevation={0}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 3,
                  p: 2.5, 
                  height: '100%',
                  background: 'linear-gradient(135deg, #141414 0%, #0a0a0a 100%)',
                  border: '1px solid rgba(212, 175, 55, 0.15)',
                  borderRadius: '6px',
                  position: 'relative',
                  overflow: 'hidden',
                  transition: 'all 0.4s ease',
                  
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    height: '50%',
                    background: 'linear-gradient(to bottom, rgba(255,255,255,0.05), transparent)',
                    pointerEvents: 'none',
                  },
                  
                  '&:hover': { 
                    borderColor: '#d4af37',
                    transform: 'translateY(-4px)', 
                    boxShadow: '0 20px 40px rgba(0, 0, 0, 0.8), 0 0 20px rgba(212, 175, 55, 0.2)',
                    '& .icon-box': {
                      backgroundColor: 'rgba(212, 175, 55, 0.1)',
                      borderColor: '#d4af37',
                      color: '#d4af37',
                    }
                  },
                }}
              >
                {/* Left: Premium Gold Accent Icon */}
                <Box
                  className="icon-box"
                  sx={{
                    minWidth: '50px',
                    height: '50px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '4px',
                    backgroundColor: 'rgba(212, 175, 55, 0.05)',
                    border: '1px solid rgba(212, 175, 55, 0.3)',
                    color: '#d4af37',
                    transition: 'all 0.4s ease',
                    '& svg': { fontSize: '1.8rem' },
                  }}
                >
                  {item.icon}
                </Box>

                {/* Right: Refined Text */}
                <Box sx={{ flex: 1 }}>
                  <Typography 
                    variant="h6" 
                    component="h3" 
                    sx={{ 
                      fontFamily: "'Playfair Display', serif", 
                      color: '#ffffff', 
                      fontSize: '1.1rem', 
                      lineHeight: 1.3, 
                      mb: 0.5,
                      fontWeight: 600
                    }}
                  >
                    {item.title}
                  </Typography>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      color: '#a1a1a1', 
                      fontSize: '0.8rem', 
                      lineHeight: 1.5 
                    }}
                  >
                    {item.desc}
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default Features;